module.exports = initNECaptcha;